export default __webpack_public_path__ + "static/article-renovation-diy-684a93ff2d17ab553e733732f51d0e36.jpg";